import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router";
import { Row, Container, Col, Button, Tabs, Tab } from "react-bootstrap";
import {
  EmptyCard,
  Radio,
  ContainerGrid,
  GroupIcons,
  TitleProduct,
  Box,
  Center,
  Line,
} from "./styles";
import { BsPencil, BsTrash } from "react-icons/bs";
import {
  deleteAddress,
  addAddress,
  editAddresses,
} from "../../components/AddressComponent/services/addressService";
import notify from "../../components/UI/toast";
import ModalApp from "../../components/ModalApp";
import { FormatCurrency, FormatPoints } from "../../lib";
import { LoaderSmall } from "../../components/Loader";
import { useUserData } from "../../hooks/UserContext";
import AddressComponent from "../../components/AddressComponent";
import ErrorBoundary from "../../components/ErrorBoundary";
import Footer from "../../components/Footer";
import Title from "../../components/Title";
import ListTabContent from "./ListTabContent";
import { useSelector, useDispatch } from "react-redux";
import { getCart, setPaymentMethod } from "../../Redux/cartSlice";
import { swalCustom } from "../../utils/functions";
import useLocalStorage from "hooks/useLocalStorage";
import { useApp } from "../../contexts/AppContext";
import { Total, LabelText } from "./styles";
import { trackBeginCheckoutMarketplaceItems } from "../../utils/gtm";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";

export default function OrderResume() {
  const navigate = useNavigate();
  const screenName = useScreenTracking();

  //const [mainAddress, setMainAddress] = useLocalStorage("mainAddress");

  const [address, setAddress] = useState({});
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("dinheiro");
  const { whitelabel } = useApp();
  const [displayMode, setDisplayMode] = useState(whitelabel?.payment_mode);

  useEffect(() => {
    setDisplayMode(whitelabel?.payment_mode);
  }, [whitelabel]);
  
  const {
    user,
    changeAddress,
    addressesData,
    addressShipping,
    setUpdateAddresses,
    mainAddress,
    cartItemsError
  } = useUserData();

  //const addressesData = null;

  const [showPaymentWarning, setShowPaymentWarning] = useState(false);

  const dispatch = useDispatch();

  const { cart, loading } = useSelector((state) => state.cartSlice);

  const reasons = {
    cant_delivery: "Não é possível fazer a entrega para o endereço informado.",
    invalid_quantity:
      "A quantidade informada não está disponível para este produto.",
    dropped_items:
      "Um ou mais itens foram removidos da sacola por falta de estoque.",
  };

  const isSafraAddress = (addr) =>
    addr?.fixed === 1;

  const safraAddressMessage =
    "Este é seu endereço de cadastro no Safra. Para alterá-lo é necessário entrar em contato com o banco.";

  const sendOrderResumeAnalytics = (customTitle) => {
    trackClick({
      title: customTitle,
      contentType: "checkout",
      screenName,
      tagId: tagIdFromLegacySuffix("15"),
    });
  };

  function deletarEndereco(addressInfo) {
    if (isSafraAddress(addressInfo)) {
      notify(safraAddressMessage, "info");
      return;
    }
    const addressUuid = addressInfo?.uuid;
    if (!addressUuid) return;
    swalCustom
      .fire({
        html: '<p class="fw-light fs-5 mb-0">Deseja excluir este endereço?</p>',
        showCancelButton: true,
        confirmButtonText: "EXCLUIR",
        cancelButtonText: "CANCELAR",
        icon: "question",
      })
      .then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          var message = "";
          var type = "success";
          deleteAddress(user.cpf, addressUuid)
            .then((response) => {
                 message = response.message;
            })
            .catch((error) => {
              message = error.message;
              type = "error";
            })
            .finally(() => {
              notify(message, type);
              setUpdateAddresses(new Date());
              refreshResume();
            });
        }
      });
  }

  async function handleEndereco(address) {
    if (isSafraAddress(address)) {
      notify(safraAddressMessage, "info");
      return;
    }
    let result = null;
    address["customerUuid"] = user.uuid;

    if (address.uuid) {
      result = await editAddresses(user.cpf, address);
    } else {
      result = await addAddress(user.cpf, address);
    }

    if (!result.status) {
      notify(result.message, "error");
      return;
    }
    notify(result.message, "success");
    setUpdateAddresses(new Date());
    window.location.reload();
    refreshResume();
  }

  function editarEndereco(selectedAddress) {
    if (isSafraAddress(selectedAddress)) {
      notify(safraAddressMessage, "info");
      return;
    }
    setAddress(selectedAddress);
    setOpen(true);
  }

  function adicionarEndereco() {
    setAddress({});
    setOpen(true);
  }

  function refreshResume() {
    setOpen(false);
  }

  const handleCheckout = () => {
    // if (cart.warning) {
    //   return;
    // }
    if (disable()) {
      return;
    }

    if (!Object.keys(addressShipping).length) {
      notify("Selecione o endereço de entrega!", "error");
      return;
    }
    trackBeginCheckoutMarketplaceItems(cart?.items);

    sendOrderResumeAnalytics("próximo");

    navigate("/loja/orderresumepag/");
  };

  const triggerWarning = (reason) => {
    notify(reason, "error");
  };
  const handleAddress = (uuid) => {
    //dispatch(setLoading({value: true}))
    let address_selected = addressesData.find((a) => a.uuid === uuid);
    if (address_selected) {
      changeAddress(address_selected);
      refreshResume();
    }
  };

  const handleDefaultChecked = (address, index) => {
    //return true;
    // !Object.keys(addressShipping).length
    //   ? index === 0 && true
    //   : addressShipping.uuid === address.uuid && true;

    if (Object.keys(addressShipping).length === 0) {
      return index === 0;
    } else {
      return addressShipping.uuid === address.uuid;
    }
  };

  const handlePaymentMethod = (type) => {
    const textType = type ? "dinheiro" : "pontos";

    dispatch(setPaymentMethod({ value: textType }));
    setTab(textType);

    if (textType === "pontos" && cart.minimum_payments.TIM > user.balance) {
      setShowPaymentWarning(true); // Mostra o aviso se não houver pontos suficientes
      return;
    } else {
      setShowPaymentWarning(false); // Esconde o aviso se houver pontos suficientes
    }
  };

  const totalPoints = () => {

    let total = 0;
  
    cart.items.forEach(item => {
      total += item.price.points.offer * item.quantity;
    });
    
    Object.keys(cart.shipping_by_brand).forEach(brandUuid => {
      total += cart.shipping_by_brand[brandUuid].shipping_point;
    });
    
    return total;

  }

  const disable = () => {
    if (
      cart?.minimum_payments &&
      cart?.minimum_payments?.TIM &&
      tab === "pontos"
    ) {
      if (cart.minimum_payments.TIM > user.balance) {
        return true;
      }
    }
    return false;
  };

  const addressMain = addressesData?.find((address) => address.main === "1");

  const firstNonMainAddress = addressesData?.find(
    (address) => address.main !== "1"
  );

  const addressToDisplay = addressMain || firstNonMainAddress;

  if (loading) return <LoaderSmall />;

  return (
    <>
      <ModalApp show={open} handleModal={() => setOpen(false)}>
        <AddressComponent
          onConfirm={handleEndereco}
          onCancel={() => setOpen(false)}
          address={address}
        />
      </ModalApp>
      <ErrorBoundary>
        <div className="wl-page mt-4">
          <Container>
            <Title label="Resumo da compra" />
            <div className="w-full mt-5">
              {cart?.items?.length > 0 ? (
                <>
                  <Tabs
                    id="controlled-tab-cart"
                    activeKey={tab}
                    onSelect={(k) => setTab(k)}
                    variant="pills"
                    className="skills-tabs mt-4 d-none"
                  >
                    <Tab
                      tabClassName="skills-tab"
                      eventKey="dinheiro"
                      title="Dinheiro"
                    >
                      <ListTabContent
                        items={cart?.items}
                        tab={tab}
                        warning={cart?.warning}
                        shippingByBrandData={cart.shipping_by_brand}
                        addressToDisplay={addressToDisplay}
                        adicionarEndereco={adicionarEndereco}
                        displayMode={displayMode}
                      />
                    </Tab>
                  </Tabs>
                  <Box>
                    <Row className="pt-3 mb-4">
                      <Col>
                        <Total className="text-mg text-base font-wl-700 m-0">
                          Total do Pedido
                        </Total>
                      </Col>
                      <Col className="text-end">
                        {displayMode === "money" && (
                          <Total className="text-mg  font-wl-700 text-base my-1">
                            {FormatCurrency(cart.summary.total)}
                          </Total>
                        )}

                        {displayMode === "points" && (
                          <Total className="text-mg font-wl-700 text-base my-1">
                            {FormatPoints(totalPoints())} pts
                          </Total>
                        )}

                        {displayMode === "both" && (
                          <>
                            <Total className="text-mg font-wl-700 text-base color-text-dark my-1">
                              {FormatCurrency(cart.summary.total)}
                            </Total>
                            <Total className="text-mg font-wl-700 text-base color-text-dark my-1">
                              Ou {FormatPoints(totalPoints())} pts
                            </Total>
                          </>
                        )}
                      </Col>
                    </Row>
                  </Box>
                </>
              ) : (
                <EmptyCard className="mx-4">
                  <LabelText className="font-wl-500 text-center">
                    Você ainda não adicionou produtos a sua sacola.
                  </LabelText>
                  <div
                    id="goHomeButton"
                    className="d-flex align-items-center justify-content-center"
                  >
                    <Button
                      type="button"
                      className="btn-default-wl text-xxs"
                      style={{
                        width: 180,
                        heigh: 30,
                      }}
                      onClick={() => navigate("/loja")}
                    >
                      IR PARA HOME
                    </Button>
                  </div>
                  <Line />
                  <Row className="pt-3 mb-4">
                    <Col>
                      <Total className="text-base font-wl-700 color-text-dark m-0">
                        Total do Pedido
                      </Total>
                    </Col>
                    <Col className="text-end">
                      {displayMode === "money" && (
                          <Total className="text-mg  font-wl-700 text-base my-1">
                            {FormatCurrency("0")}
                          </Total>
                        )}

                        {displayMode === "points" && (
                          <Total className="text-mg font-wl-700 text-base my-1">
                            {FormatPoints(0)} pts
                          </Total>
                        )}

                        {displayMode === "both" && (
                          <>
                            <Total className="text-mg font-wl-700 text-base color-text-dark my-1">
                              {FormatCurrency("0")}
                            </Total>
                            <Total className="text-mg font-wl-700 text-base color-text-dark my-1">
                              Ou {FormatPoints(0)} pts
                            </Total>
                          </>
                        )}
                    </Col>
                  </Row>
                </EmptyCard>
              )}
            </div>
          </Container>
        </div>
        <Box className="py-3" style={{ backgroundColor: "#F6F6F6" }}>
          <Row className="m-3">
            <p className="font-wl-500 text-mg color-wl">
              {addressesData ? "Endereço de entrega" : "Entrega"}
            </p>

            <Col>
              {mainAddress ? (
                <>
                  <div
                    className="d-flex flex-column gap-26"
                    key={mainAddress.uuid}
                  >
                    <p className="mt-2 mb-2 font-wl-600 text-muted-wl">
                      {mainAddress.label}
                    </p>

                    <div style={{ color: "#050922" }}>
                      <p className="mb-0 text-sm ">
                        {" "}
                        {mainAddress.streetName}, {mainAddress.number}{" "}
                      </p>
                      <p className="mb-0 text-sm">
                        {" "}
                        {mainAddress.neighborhood}, {mainAddress.complement}{" "}
                      </p>
                      <p className="mb-0 text-sm">
                        {" "}
                        {mainAddress.city +
                          ", " +
                          mainAddress.state +
                          " - " +
                          mainAddress.zipCode}
                      </p>
                    </div>
                    {mainAddress && isSafraAddress(mainAddress) && (
                      <div className="mt-3" style={{ width: "70%" }}>
                        <p className="text-xs mb-1 text-text_primary_color italic">
                          {safraAddressMessage}
                        </p>
                      </div>
                    )}
                    <div className="my-4">
                      <a
                        className="link-default-wl color-opacty-60 text-sm"
                        onClick={() => {
                          sendOrderResumeAnalytics("alterar-endereco");
                          //window.location.assign("/loja/list-addresses")
                          navigate("/loja/list-addresses")
                        }}
                        style={{
                          fontWeight: 700,
                          color: whitelabel?.text_primary_color
                        }}
                      >
                        Alterar endereço
                      </a>
                    </div>
                  </div>
                </>
              ) : addressToDisplay ? (
                <div className="d-flex flex-column gap-26">
                  <p className="mt-2 mb-2 color-wl font-wl-600 text-muted-wl">
                    {addressToDisplay.label}
                  </p>

                  <div style={{ color: `${whitelabel?.text_primary_color}` }}>
                    <p className="mb-0 text-sm ">
                      {" "}
                      {addressToDisplay.streetName}, {addressToDisplay.number}{" "}
                    </p>
                    <p className="mb-0 text-sm">
                      {" "}
                      {addressToDisplay.neighborhood},{" "}
                      {addressToDisplay.complement}{" "}
                    </p>
                    <p className="mb-0 text-sm">
                      {" "}
                      {addressToDisplay.city +
                        ", " +
                        addressToDisplay.state +
                        " - " +
                        addressToDisplay.zipCode}
                    </p>
                  </div>
                  {addressToDisplay && isSafraAddress(addressToDisplay) && (
                    <div className="mt-3" style={{ width: "70%" }}>
                      <p className="text-xs mb-1 text-text_primary_color italic">
                        {safraAddressMessage}
                      </p>
                    </div>
                  )}
                  <div className="my-4">
                    <a
                      className="link-default-wl"
                      onClick={() => {
                        sendOrderResumeAnalytics("alterar-endereco");
                        //window.location.assign("/loja/list-addresses")
                        navigate("/loja/list-addresses")
                      }}
                      style={{
                        color: whitelabel?.text_primary_color,
                        fontWeight: 700,
                      }}
                    >
                      Alterar endereço
                    </a>
                  </div>
                </div>
              ) : (
                <div>
                  <p className="mb-0 text-sm ">
                    {" "}
                    Cadastre o endereço que deseja receber seu <br /> pedido
                    para seguir com a compra.{" "}
                  </p>
                  <div className="mt-4">
                    <a
                      className="link-default-wl"
                      onClick={() => adicionarEndereco()}
                      style={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: 700 }}
                    >
                      Adicionar Endereço
                    </a>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </Box>
        <Footer orderResume={true}>
          <Button
            type="button"
            className={`btn-default-wl text-xs ${
              cart.warning || (disable() && "disable")
            }`}
            disabled={!cart.items.length || (cartItemsError && cartItemsError.item)}
            onClick={() => handleCheckout()}
          >
            PRÓXIMO
          </Button>
          <Button
            type="button"
            className={`btn-outline-wl text-xs ${
              cart.warning || (disable() && "disable")
            }`}
            onClick={() => {
              sendOrderResumeAnalytics("continuar-comprando");
              navigate("/loja");
            }}
          >
            CONTINUAR COMPRANDO
          </Button>
        </Footer>
      </ErrorBoundary>
    </>
  );
}
